import flatten from "lodash/flatten";
import times from "lodash/times";
import { WSQueryCache, WSQueryConfig } from "@ws-react-query";
import {
  getPayeeRows,
  getPayeeRowsSummary,
  IPayeeRow,
  PayeeRowsQuery
} from "../../../../services/search";
import { useXWingspanExpansion } from "../../../../shared/hooks/useXWingspanExpansion";
import {
  concurrentActions,
  WSServiceError
} from "../../../../utils/serviceHelper";
import { useWSQuery } from "../../../helpers";

const PAGE_SIZE = 500;

export const QUERY_ALL_PAYEE_ROWS = "QUERY_ALL_PAYEE_ROWS";

export const fetchAllPayeeRows = async (
  requestQuery?: PayeeRowsQuery,
  xWingspanExpansion?: string,
  inQuery?: boolean
) => {
  if (!inQuery) {
    const cached = WSQueryCache.getQueryData<IPayeeRow[]>([
      QUERY_ALL_PAYEE_ROWS,
      requestQuery,
      xWingspanExpansion
    ]);

    if (cached) {
      return cached;
    }
  }

  const summary = await getPayeeRowsSummary(requestQuery, xWingspanExpansion);
  const pages = Math.ceil(summary.listSize / PAGE_SIZE);

  const actions = times(pages).map(
    (_, i) => () =>
      getPayeeRows(
        {
          ...requestQuery,
          page: {
            size: PAGE_SIZE,
            number: i + 1
          }
        },
        xWingspanExpansion
      )
  );

  const allPages = await concurrentActions(actions, {
    concurrentLimit: 5
  });

  const payload = flatten(allPages);

  if (!inQuery) {
    WSQueryCache.setQueryData(
      [QUERY_ALL_PAYEE_ROWS, requestQuery, xWingspanExpansion],
      payload
    );
  }

  return payload;
};

export const useQueryAllPayeeRows = (
  requestQuery?: PayeeRowsQuery,
  config?: WSQueryConfig<IPayeeRow[], WSServiceError>
) => {
  const xWingspanExpansion = useXWingspanExpansion();

  return useWSQuery<IPayeeRow[], WSServiceError>(
    [QUERY_ALL_PAYEE_ROWS, requestQuery, xWingspanExpansion],
    async () => {
      return fetchAllPayeeRows(requestQuery, xWingspanExpansion, true);
    },
    {
      staleTime: Infinity,
      refetchOnMount: false,
      ...config
    }
  );
};
